module.exports = "<app-course-pattern-list></app-course-pattern-list>"